"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deepFreeze;
/**
 * Freezes the object
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function deepFreeze(o) {
  Object.freeze(o);
  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (Object.hasOwnProperty.call(o, prop) && o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop]);
    }
  });
  return o;
}
module.exports = exports.default;
//# sourceMappingURL=deepFreeze.js.map